import { render, staticRenderFns } from "./_totalPlayedMiniGameDetailOperator.vue?vue&type=template&id=bb524a44&lang=pug"
import script from "./_totalPlayedMiniGameDetailOperator.vue?vue&type=script&lang=js"
export * from "./_totalPlayedMiniGameDetailOperator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports